var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-base',{on:{"onPrev":function($event){return _vm.onPrev()},"onNext":function($event){return _vm.onNext()}}},[_c('survey',{attrs:{"survey":_vm.survey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }